import { Button, Input, Modal } from 'glintly-ui';
import styles from '../services.module.css';
import ServiceTagsField from '../ServiceTagsField';
import { useCreateProduct, useVendorTagSuggestions } from '../../../../api';

const CreateServiceModal = ({
  showCreateModal,
  setFormData,
  setShowCreateModal,
  userId,
  resetForm,
  handleCreateProduct,
  handleInputChange,
  formData,
}) => {
  const { data: tagSuggestions } = useVendorTagSuggestions(userId);
  const createProductMutation = useCreateProduct();

  const categories = [
    'Haircut',
    'Beard Trim',
    'Hair Wash',
    'Hair Styling',
    'Hair Color',
    'Facial',
    'Massage',
    'Other',
  ];

  return (
    <Modal
      isOpen={showCreateModal}
      onClose={() => {
        setShowCreateModal(false);
        resetForm();
      }}
      size="lg"
    >
      <Modal.Header style={{ padding: '10px' }}>Add New Service</Modal.Header>
      <Modal.Body>
        <div>
          <form onSubmit={handleCreateProduct}>
            <div className={styles.serviceFormGrid}>
              <div className={`${styles.serviceFormField} ${styles.serviceFormHalf}`}>
                <Input.Root name="name" required>
                  <Input.Label>Service Name</Input.Label>
                  <Input.Control
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Enter service name"
                  />
                </Input.Root>
              </div>
              <div className={`${styles.serviceFormField} ${styles.serviceFormHalf}`}>
                <Input.Root name="sku" required>
                  <Input.Label>SKU</Input.Label>
                  <Input.Control
                    value={formData.sku}
                    onChange={handleInputChange}
                    placeholder="Enter SKU"
                  />
                </Input.Root>
              </div>
              <div className={styles.serviceFormField}>
                <Input.Root name="description">
                  <Input.Label required>Description</Input.Label>
                  <Input.Control
                    type="textarea"
                    value={formData.description}
                    onChange={handleInputChange}
                    placeholder="Enter service description"
                    rows={3}
                  />
                </Input.Root>
              </div>
              <div className={`${styles.serviceFormField} ${styles.serviceFormHalf}`}>
                <Input.Root name="price" required>
                  <Input.Label>Price (₹)</Input.Label>
                  <Input.Control
                    type="number"
                    value={formData.price}
                    onChange={handleInputChange}
                    placeholder="Enter price"
                  />
                </Input.Root>
              </div>
              <div className={`${styles.serviceFormField} ${styles.serviceFormHalf}`}>
                <Input.Root name="stock" required>
                  <Input.Label>Stock</Input.Label>
                  <Input.Control
                    type="number"
                    value={formData.stock}
                    onChange={handleInputChange}
                    placeholder="Enter stock quantity"
                  />
                </Input.Root>
              </div>
              <div className={`${styles.serviceFormField} ${styles.serviceFormHalf}`}>
                <Input.Root name="category" required>
                  <Input.Label>Category</Input.Label>
                  <Input.Control
                    type="select"
                    value={formData.category}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        category: e.target.value,
                      }))
                    }
                    options={categories.map((cat) => ({
                      label: cat,
                      value: cat,
                    }))}
                    placeholder="Select category"
                  />
                </Input.Root>
              </div>
              <div className={`${styles.serviceFormField} ${styles.serviceFormHalf}`}>
                <Input.Root name="status">
                  <Input.Label>Status</Input.Label>
                  <Input.Control
                    type="select"
                    value={formData.status}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        status: e.target.value,
                      }))
                    }
                    options={[
                      { label: 'Active', value: 'ACTIVE' },
                      { label: 'Inactive', value: 'INACTIVE' },
                    ]}
                  />
                </Input.Root>
              </div>
              <div className={`${styles.serviceFormField} ${styles.serviceFormHalf}`}>
                <Input.Root name="brand">
                  <Input.Label>Brand</Input.Label>
                  <Input.Control
                    value={formData.brand}
                    onChange={handleInputChange}
                    placeholder="Enter brand name"
                  />
                </Input.Root>
              </div>
              <ServiceTagsField
                formData={formData}
                setFormData={setFormData}
                suggestionData={tagSuggestions}
              />
              <div className={styles.serviceFormField}>
                <Input.Root name="notes">
                  <Input.Label>Notes</Input.Label>
                  <Input.Control
                    type="textarea"
                    value={formData.notes}
                    onChange={handleInputChange}
                    placeholder="Enter any additional notes"
                    rows={3}
                  />
                </Input.Root>
              </div>
            </div>

            <div className={styles.modalActions}>
              <Button
                type="button"
                variant="outline"
                onClick={() => {
                  setShowCreateModal(false);
                  resetForm();
                }}
              >
                Cancel
              </Button>
              <Button type="submit" variant="primary" disabled={createProductMutation.isPending}>
                {createProductMutation.isPending ? 'Creating...' : 'Create Service'}
              </Button>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CreateServiceModal;
